var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: ["emd-modal", _vm.open ? "_active" : ""],
      staticStyle: { "z-index": "10000" },
    },
    [
      _c("div", { staticClass: "emd-modal__background" }),
      _c(
        "div",
        { class: ["emd-modal__content", ..._vm.classList] },
        [_vm._t("content")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }